import { AuthUser } from '@aws-amplify/auth';
import { UseAuthenticator } from '@aws-amplify/ui-react';
import * as React from 'react';

export interface AmplifyContextProps {
  signOut: UseAuthenticator['signOut'] | undefined;
  user: AuthUser | undefined | any;
}

export const AmplifyContext = React.createContext<AmplifyContextProps>(null as unknown as AmplifyContextProps);

export default function useAmplifyContext() {
  return React.useContext(AmplifyContext);
}
